import React, { useState } from "react";
import { createAccessRequest } from "../../api/admin";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import { getUserFacingErrorMessage } from "../../utils/userFacingError";

interface Props {
  eventId: number;
  eventTitle: string;
  onRequestSubmitted: () => void;
}

export default function RequestFullManagementAccess({
  eventId,
  eventTitle,
  onRequestSubmitted,
}: Props) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleRequest = async () => {
    setIsSubmitting(true);
    setError(null);
    try {
      await createAccessRequest(
        eventId,
        "Requesting upgrade to full management",
      );
      onRequestSubmitted();
    } catch (err) {
      setError(
        getUserFacingErrorMessage(err, "Could not submit request."),
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col items-end gap-1">
      <button
        type="button"
        className="text-xs text-slate-700 underline disabled:opacity-50"
        disabled={isSubmitting}
        onClick={handleRequest}
        title={`Request full management for ${eventTitle}`}
      >
        {isSubmitting ? "Submitting…" : "Request full management"}
      </button>
      {error && <ErrorAlert inline>{error}</ErrorAlert>}
    </div>
  );
}
